export function setClientPath(thisClientPath) {

  return { 
  	type: 'CLIENTPATH', 
  	thisClientPath 
  }
}


// WEBPACK FOOTER //
// ./src/redux/actions/clientPath.js